import { IContact } from '@nkr/models/index';
import { SwapGridWrapper } from '../styles';

interface IProps {
    data: IContact,
    sidebar?: boolean
}

const SwapManager = (props: IProps) => {
    return (
        <SwapGridWrapper condensed bordered style={{ width: 'initial', fontSize: props.sidebar ? 12 : null }}>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{props.data.fullName}</td>
                    <td>{props.data.email}</td>
                </tr>
            </tbody>
        </SwapGridWrapper>
    );
}

export default SwapManager;